export default {"src":"/trader-new/_next/static/media/NTCFooterActive.0cd49596.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};